export default "__VITE_ASSET__CI4YzBUu__"